import { render, staticRenderFns } from "./ChangeProviderPlan.vue?vue&type=template&id=bd7e70b0"
import script from "./ChangeProviderPlan.vue?vue&type=script&lang=js"
export * from "./ChangeProviderPlan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports